import { SDK, ServerOptions } from '@commercetools/frontend-sdk';

import {
  GetContentByDeliveryKey,
  GetContentListByContentType,
} from 'sdk/composable-commerce/types/actions/AmplienceActions';
import { ComposableCommerceEvents } from '../../types/events/ComposableCommerceEvents';
import { GetContentTypeByPagination } from 'sdk/composable-commerce/types/queries/AmplienceQueries';
import { AmplienceContentTypePaginated } from 'shared/types/amplience/Amplience';

export type AmplienceActions = {
  getContentByDeliveryKey: GetContentByDeliveryKey;
  getContentListByContentType: GetContentListByContentType;
};

export const getAmplienceActions = (sdk: SDK<ComposableCommerceEvents>): AmplienceActions => {
  return {
    getContentByDeliveryKey: async (
      deliveryKey: string,
      options: {
        parallel?: boolean;
        customHeaderValue?: string;
        serverOptions?: ServerOptions;
      } = {},
    ) => {
      const response = await sdk.callAction({
        actionName: 'amplience/getContentByDeliveryKey',
        query: { deliveryKey },
        parallel: options.parallel,
        customHeaderValue: options.customHeaderValue,
        serverOptions: options.serverOptions,
      });

      return response;
    },

    getContentListByContentType: async (
      query: GetContentTypeByPagination,
      options: {
        parallel?: boolean;
        customHeaderValue?: string;
        serverOptions?: ServerOptions;
      } = {},
    ) => {
      const { contentType, limit, nextCursor } = query;
      const response = await sdk.callAction<AmplienceContentTypePaginated>({
        actionName: 'amplience/getContentList',
        query: { contentType, limit: limit ?? 10, nextCursor: nextCursor ?? '' },
        parallel: options.parallel,
        customHeaderValue: options.customHeaderValue,
        serverOptions: options.serverOptions,
      });

      return response;
    },
  };
};
